<div class="contacts-page">
  <a
    [routerLink]="routes.contacts"
    class="contacts-back"
    [title]="'common.backToList' | translate"
    [attr.aria-label]="'common.backToList' | translate"
    >
    <fa-icon icon="arrow-left"></fa-icon>
  </a>

  @if (loading) {
    <p class="contacts-status">{{ 'common.loading' | translate }}</p>
  }
  @if (error) {
    <p class="contacts-status contacts-status--error">
      {{ 'contacts.fiche.loadError' | translate }}
    </p>
  }

  @if (!loading && !error && contact; as current) {
    @if (!editMode) {
      <header class="contacts-header">
        <div class="contacts-header-row">
          <div class="contacts-header-main">
            <h2 class="contacts-title">
              {{ current.prenomDto || '' }} {{ current.nomDto || '' }}
            </h2>
            <p class="contacts-subtitle">
              {{ 'contacts.statutPrefix' | translate }}
              {{ statutLabel() | translate }}
            </p>
          </div>
          <div class="contacts-header-actions">
            <button
              type="button"
              class="contacts-row-action"
              [title]="'contacts.fiche.edit' | translate"
              [attr.aria-label]="'contacts.fiche.edit' | translate"
              [disabled]="deleting || phoneSaving || refusing || reopening"
              (click)="startEdit()"
              >
              <fa-icon icon="pen"></fa-icon>
            </button>
            <button
              type="button"
              class="contacts-row-action contacts-row-action--danger"
              [title]="'contacts.fiche.delete' | translate"
              [attr.aria-label]="'contacts.fiche.delete' | translate"
              [disabled]="deleting || phoneSaving || refusing || reopening"
              (click)="askDelete()"
              >
              <fa-icon [icon]="['far', 'trash-can']"></fa-icon>
            </button>
          </div>
        </div>
        @if (canRefuse() || canReopen()) {
          <div class="contacts-status-actions">
            @if (canRefuse()) {
              <button
                type="button"
                class="contacts-action-btn contacts-action-btn--danger"
                [disabled]="deleting || phoneSaving || refusing || reopening"
                (click)="askRefuse()"
                >
                {{ 'contacts.fiche.refuse' | translate }}
              </button>
            }
            @if (canReopen()) {
              <button
                type="button"
                class="contacts-action-btn"
                [disabled]="deleting || phoneSaving || refusing || reopening"
                (click)="askReopen()"
                >
                {{ 'contacts.fiche.reopen' | translate }}
              </button>
            }
          </div>
        }
      </header>
    }
    @if (!editMode) {
      <section class="contacts-card">
        <dl class="contacts-details">
          <div>
            <dt>{{ 'contacts.fiche.civilite' | translate }}</dt>
            <dd>
              {{
              current.civiliteDto
              ? (current.civiliteDto | i18nValue: 'ref.civilite')
              : ('common.dash' | translate)
              }}
            </dd>
          </div>
          <div>
            <dt>{{ 'contacts.fiche.nom' | translate }}</dt>
            <dd>{{ current.nomDto || ('common.dash' | translate) }}</dd>
          </div>
          <div>
            <dt>{{ 'contacts.fiche.prenom' | translate }}</dt>
            <dd>{{ current.prenomDto || ('common.dash' | translate) }}</dd>
          </div>
          <div>
            <dt>{{ 'contacts.fiche.email' | translate }}</dt>
            <dd>{{ current.mailDto || ('common.dash' | translate) }}</dd>
          </div>
          <div>
            <dt>{{ 'contacts.fiche.dateEntree' | translate }}</dt>
            <dd>
              {{
              (current.dateEntreeRelationDto | date: 'dd/MM/yyyy') ||
              ('common.dash' | translate)
              }}
            </dd>
          </div>
          @if (current.motifRefusDto) {
            <div>
              <dt>{{ motifRefusLabel() | translate }}</dt>
              <dd>{{ current.motifRefusDto }}</dd>
            </div>
          }
          @if (current.dateRefusDto) {
            <div>
              <dt>{{ dateRefusLabel() | translate }}</dt>
              <dd>{{ current.dateRefusDto | date: 'dd/MM/yyyy' }}</dd>
            </div>
          }
          <div>
            <dt>{{ 'contacts.fiche.notes' | translate }}</dt>
            <dd>{{ current.notesDto || ('common.dash' | translate) }}</dd>
          </div>
        </dl>
      </section>
    }
    @if (editMode) {
      <section class="contacts-card contacts-card--edit">
        <h3>{{ 'contacts.fiche.edit' | translate }}</h3>
        <form class="contacts-form" [formGroup]="form" (ngSubmit)="save()">
          <label>
            <span>{{ 'contacts.fiche.civilite' | translate }}</span>
            <select formControlName="civilite" autocomplete="honorific-prefix">
              <option value="">{{ 'common.dash' | translate }}</option>
              @for (civilite of civilites; track civilite) {
                <option [value]="civilite">
                  {{ civilite | i18nValue: 'ref.civilite' }}
                </option>
              }
            </select>
          </label>
          <label>
            <span>{{ 'contacts.fiche.nomRequired' | translate }}</span>
            <input type="text" formControlName="nom" />
          </label>
          <label>
            <span>{{ 'contacts.fiche.prenomRequired' | translate }}</span>
            <input type="text" formControlName="prenom" />
          </label>
          <label>
            <span>{{ 'contacts.fiche.email' | translate }}</span>
            <input type="email" formControlName="mail" />
          </label>
          <label>
            <span>{{ 'contacts.fiche.notes' | translate }}</span>
            <textarea rows="4" formControlName="notes"></textarea>
          </label>
          @if (formError) {
            <p class="contacts-status contacts-status--error">
              {{ 'contacts.fiche.saveError' | translate }}
            </p>
          }
          <div class="contacts-form-actions">
            <button
              type="button"
              class="contacts-cancel"
              [disabled]="saving"
              (click)="cancelEdit()"
              >
              {{ 'common.cancel' | translate }}
            </button>
            <button type="submit" class="contacts-action-btn" [disabled]="saving">
              {{
              saving
              ? ('common.saving' | translate)
              : ('common.save' | translate)
              }}
            </button>
          </div>
        </form>
      </section>
    }
    @if (!editMode) {
      <section class="contacts-card contacts-card--phones">
        <h3 class="contacts-section-title">
          {{ 'contacts.fiche.telephones' | translate }}
          <app-help-tip textKey="contacts.fiche.telephonesHint" />
        </h3>
        @if (phones().length > 0) {
          <ul class="contacts-phone-list">
            @for (phone of phones(); track phone) {
              <li class="contacts-phone-row">
                <div>
                  <p class="contacts-phone-number">
                    {{ phone.numeroDto }}
                    @if (phone.parDefautDto) {
                      <span class="contacts-phone-badge">{{
                        'contacts.fiche.parDefaut' | translate
                      }}</span>
                    }
                  </p>
                  @if (phone.libelleDto) {
                    <p class="contacts-phone-meta">
                      {{ phone.libelleDto }}
                    </p>
                  }
                  @if (phone.dateAjoutDto) {
                    <p class="contacts-phone-meta">
                      {{
                      'contacts.fiche.ajouteLe'
                      | translate
                      : { date: (phone.dateAjoutDto | date: 'dd/MM/yyyy') }
                      }}
                    </p>
                  }
                </div>
                <div class="contacts-phone-actions">
                  @if (!phone.parDefautDto) {
                    <button
                      type="button"
                      class="contacts-cancel"
                      [disabled]="phoneSaving"
                      (click)="setDefaultPhone(phone)"
                      >
                      {{ 'contacts.fiche.setDefault' | translate }}
                    </button>
                  }
                  <button
                    type="button"
                    class="contacts-cancel"
                    [disabled]="phoneSaving"
                    (click)="archivePhone(phone)"
                    >
                    {{ 'contacts.fiche.archive' | translate }}
                  </button>
                </div>
              </li>
            }
          </ul>
        }
        @if (phones().length === 0) {
          <p class="contacts-status">
            {{ 'contacts.fiche.noPhone' | translate }}
          </p>
        }
        <form
          class="contacts-form contacts-phone-form"
          [formGroup]="phoneForm"
          (ngSubmit)="addPhone()"
          >
          <div class="contacts-form-row">
            <label>
              <span>{{ 'contacts.fiche.newNumber' | translate }}</span>
              <input type="tel" formControlName="numero" />
            </label>
            <label>
              <span>{{ 'contacts.fiche.libelle' | translate }}</span>
              <input
                type="text"
                formControlName="libelle"
                [placeholder]="'contacts.fiche.libellePlaceholder' | translate"
                />
              </label>
            </div>
            @if (phoneError) {
              <p class="contacts-status contacts-status--error">
                {{ 'contacts.fiche.phoneSaveError' | translate }}
              </p>
            }
            <div class="contacts-form-actions">
              <button
                type="submit"
                class="contacts-action-btn"
                [disabled]="phoneSaving"
                >
                {{
                phoneSaving
                ? ('common.saving' | translate)
                : ('contacts.fiche.addNumber' | translate)
                }}
              </button>
            </div>
          </form>
        </section>
      }
      @if (!editMode) {
        <section class="contacts-card contacts-card--history">
          <h3 class="contacts-section-title">
            {{ 'contacts.fiche.historique' | translate }}
            <app-help-tip textKey="contacts.fiche.historiqueHint" />
          </h3>
          @if (historique().length > 0) {
            <ul class="contacts-history-list">
              @for (event of historique(); track event) {
                <li class="contacts-history-row">
                  <div>
                    <p class="contacts-history-title">
                      {{ statutEventLabel(event.statutDto) | translate }}
                      @if (event.statutPrecedentDto) {
                        <span
                          class="contacts-history-from"
                          >
                          {{
                          'contacts.fiche.depuis'
                          | translate
                          : {
                          statut:
                          (statutEventLabel(event.statutPrecedentDto)
                          | translate)
                        }
                        }}
                      </span>
                    }
                  </p>
                  @if (event.dateEvenementDto) {
                    <p class="contacts-history-meta">
                      {{ event.dateEvenementDto | date: 'dd/MM/yyyy HH:mm' }}
                    </p>
                  }
                  @if (event.motifDto) {
                    <p class="contacts-history-meta">
                      {{
                      'contacts.fiche.motifPrefix'
                      | translate: { motif: event.motifDto }
                      }}
                    </p>
                  }
                </div>
              </li>
            }
          </ul>
        }
        @if (historique().length === 0) {
          <p class="contacts-status">
            {{ 'contacts.fiche.noHistory' | translate }}
          </p>
        }
      </section>
    }
  }

  <dialog
    #deleteDialog
    class="contacts-dialog"
    aria-labelledby="delete-contact-title"
    (cancel)="onDeleteDialogCancel($event)"
    (click)="onDeleteDialogBackdropClick($event)"
    (keydown)="onDeleteDialogBackdropKeydown($event)"
    >
    @if (contact; as current) {
      <h3 id="delete-contact-title">
        {{ 'contacts.fiche.deleteTitle' | translate }}
      </h3>
      <p>
        {{
        'contacts.fiche.deleteBody'
        | translate
        : {
        name:
        (current.prenomDto || '') + ' ' + (current.nomDto || '')
      }
      }}
    </p>
    @if (deleteError) {
      <p class="contacts-status contacts-status--error">
        {{ 'contacts.fiche.deleteError' | translate }}
      </p>
    }
    <div class="contacts-dialog-actions">
      <button
        type="button"
        class="contacts-cancel"
        [disabled]="deleting"
        (click)="cancelDelete()"
        >
        {{ 'common.cancel' | translate }}
      </button>
      <button
        type="button"
        class="contacts-action-btn contacts-action-btn--danger"
        [disabled]="deleting"
        (click)="confirmDelete()"
        >
        {{
        deleting
        ? ('common.deleting' | translate)
        : ('common.delete' | translate)
        }}
      </button>
    </div>
  }
</dialog>

<dialog
  #refuseDialog
  class="contacts-dialog"
  aria-labelledby="refuse-contact-title"
  (cancel)="onRefuseDialogCancel($event)"
  (click)="onRefuseDialogBackdropClick($event)"
  (keydown)="onRefuseDialogBackdropKeydown($event)"
  >
  @if (contact; as current) {
    <h3 id="refuse-contact-title">
      {{ 'contacts.fiche.refuseTitle' | translate }}
    </h3>
    <p>
      {{
      'contacts.fiche.refuseBody'
      | translate
      : {
      name:
      (current.prenomDto || '') + ' ' + (current.nomDto || '')
    }
    }}
  </p>
  <form class="contacts-form" [formGroup]="refuseForm" (ngSubmit)="confirmRefuse()">
    <label>
      <span>{{ 'contacts.fiche.motifRefusRequired' | translate }}</span>
      <textarea rows="4" formControlName="motif"></textarea>
    </label>
    @if (refuseError) {
      <p class="contacts-status contacts-status--error">
        {{ 'contacts.fiche.refuseError' | translate }}
      </p>
    }
    <div class="contacts-dialog-actions">
      <button
        type="button"
        class="contacts-cancel"
        [disabled]="refusing"
        (click)="cancelRefuse()"
        >
        {{ 'common.cancel' | translate }}
      </button>
      <button
        type="submit"
        class="contacts-action-btn contacts-action-btn--danger"
        [disabled]="refusing"
        >
        {{
        refusing
        ? ('contacts.fiche.refusing' | translate)
        : ('contacts.fiche.confirmRefuse' | translate)
        }}
      </button>
    </div>
  </form>
}
</dialog>

<dialog
  #reopenDialog
  class="contacts-dialog"
  aria-labelledby="reopen-contact-title"
  (cancel)="onReopenDialogCancel($event)"
  (click)="onReopenDialogBackdropClick($event)"
  (keydown)="onReopenDialogBackdropKeydown($event)"
  >
  @if (contact; as current) {
    <h3 id="reopen-contact-title">
      {{ 'contacts.fiche.reopenTitle' | translate }}
    </h3>
    <p>
      {{
      'contacts.fiche.reopenBody'
      | translate
      : {
      name:
      (current.prenomDto || '') + ' ' + (current.nomDto || '')
    }
    }}
  </p>
  @if (reopenError) {
    <p class="contacts-status contacts-status--error">
      {{ 'contacts.fiche.reopenError' | translate }}
    </p>
  }
  <div class="contacts-dialog-actions">
    <button
      type="button"
      class="contacts-cancel"
      [disabled]="reopening"
      (click)="cancelReopen()"
      >
      {{ 'common.cancel' | translate }}
    </button>
    <button
      type="button"
      class="contacts-action-btn"
      [disabled]="reopening"
      (click)="confirmReopen()"
      >
      {{
      reopening
      ? ('contacts.fiche.reopening' | translate)
      : ('contacts.fiche.reopen' | translate)
      }}
    </button>
  </div>
}
</dialog>
</div>
